export default {
  processSteps: 'Kroky procesu',
};
